import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("dms_user") || "null"); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("dms_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => {
        setUser(r.data);
        localStorage.setItem("dms_user", JSON.stringify(r.data));
      })
      .catch(() => {
        localStorage.removeItem("dms_token");
        localStorage.removeItem("dms_user");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    localStorage.setItem("dms_token", res.data.access_token || res.data.token);
    if (res.data.refresh_token) localStorage.setItem("dms_refresh", res.data.refresh_token);
    localStorage.setItem("dms_user", JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem("dms_token");
    localStorage.removeItem("dms_refresh");
    localStorage.removeItem("dms_user");
    setUser(null);
  };

  // Sprint UTENTI-1: ricarica /auth/me (es. dopo cambio password forzato)
  const refreshUser = async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
      localStorage.setItem("dms_user", JSON.stringify(r.data));
      return r.data;
    } catch {
      return null;
    }
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, setUser, refreshUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

const ELEVATED_ROLES = ["developer", "admin"];

export function effectiveRole(user) {
  if (!user) return null;
  return user.role_default || (user.role || "").toLowerCase();
}

export const isDeveloper = (user) => effectiveRole(user) === "developer";

export const isElevated = (user) => ELEVATED_ROLES.includes(effectiveRole(user));

export const can = (user, action) => {
  if (!user) return false;
  const role = effectiveRole(user);
  const isAdminish = ["developer", "admin", "amministrazione"].includes(role);
  if (action === "manage_users") return ["developer", "admin"].includes(role);
  if (action === "delete_any") return ["developer", "admin"].includes(role);
  if (action === "request_delete") return isAdminish;
  if (action === "request_replace") return true;
  if (action === "rename") return isAdminish;
  if (action === "move") return isAdminish;
  if (action === "create_company") return ["developer", "admin"].includes(role);
  if (action === "edit_categories") return isAdminish;
  if (action === "upload") return true;
  return false;
};
